import { html, LitElement } from 'lit';

import { styles } from './banner-actions.styles';

export class BannerActions extends LitElement {
	static override styles = [styles()];

	override connectedCallback(): void {
		super.connectedCallback();

		// This sets the slot to which the banner-actions should be assigned inside the banner component.
		this.setAttribute('slot', 'actions');
	}

	override render() {
		return html`
			<slot name="secondary-action"></slot>
			<slot name="primary-action"></slot>
		`;
	}
}

window.customElements.define('m-banner-actions', BannerActions);

declare global {
	interface HTMLElementTagNameMap {
		'm-banner-actions': BannerActions;
	}
}
